<template>
  <div id="tTrade">
    <a-form
      name="materialForm"
      class="ant-round-form material-fill"
      label-align="left"
      :label-col="{span: 10}"
      :model="materialForm"
      :rules="materialRules"
      @finish="materialSubmit"
    >
      <a-form-item
        v-if="materialForm.tradeType === '01' && !saleWebSite"
        name="saleWebSite"
        :label="$t('pages_receive_107')"
      >
        <a-input v-model:value="materialForm.saleWebSite" :placeholder="$t('pages_receive_108')" allow-clear />
      </a-form-item>
      <a-form-item name="payerName" :label="$t('pages_receive_085')">
        <a-input v-model:value="materialForm.payerName" :placeholder="$t('common_text_006')" allow-clear />
      </a-form-item>
      <a-form-item name="payerCountry" :label="$t('pages_receive_086')">
        <a-select
          v-model:value="materialForm.payerCountry"
          option-filter-prop="label"
          allow-clear
          show-search
          :placeholder="$t('common_text_005')"
        >
          <a-select-option
            v-for="item in areaPubs"
            :key="item.id"
            :value="item.areaEnglishName"
            :label="item.areaEnglishName + item.areaChineseName"
          >{{ item.areaEnglishName }} - {{ item.areaChineseName }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 付款方式 -->
      <a-form-item v-if="materialForm.bankCode==='99999032'" name="payType" :label="$t('pages_pay_078')">
        <a-select
          v-model:value="materialForm.payType"
          option-filter-prop="label"
          allow-clear
          show-search
          :placeholder="$t('common_text_005')"
        >
          <a-select-option
            v-for="item in payTypeValue"
            :key="item.id"
            :value="item.value"
            :label="item.value"
          >{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 预付款金额 -->
      <a-form-item v-if="materialForm.payType==='01'&&materialForm.bankCode==='99999032'" name="receiveAmount" :label="$t('pages_receive_197')">
        <div style="position: relative">
          <a-input-number
            v-model:value="materialForm.receiveAmount"
            style="position: relative; padding-left: 27%; overflow: clip"
            :controls="false"
            :min="0"
            :placeholder="$t('common_text_006')"
          />
          <a-form-item-rest>
            <a-select
              v-model:value="materialForm.currency"
              show-search
              class="area-select"
              :disabled="!isAdvance && !isUpdate"
              :bordered="false"
              :show-arrow="false"
            >
              <a-select-option
                v-for="item in curList"
                :key="item.currencyCode"
                :value="item.currencyCode"
                :label="item.currencyCode"
              >{{ item.currencyCode }}</a-select-option>
            </a-select>
          </a-form-item-rest>
        </div>
      </a-form-item>
      <!-- 付款金额 -->
      <a-form-item name="totalAmount" :label="$t('pages_receive_087')">
        <div style="position: relative">
          <a-input-number
            v-model:value="materialForm.totalAmount"
            style="position: relative; padding-left: 27%; overflow: clip"
            :controls="false"
            :min="0"
            :placeholder="$t('common_text_006')"
          />
          <a-form-item-rest>
            <a-select
              v-model:value="materialForm.currency"
              show-search
              class="area-select"
              :disabled="!isAdvance && !isUpdate"
              :bordered="false"
              :show-arrow="false"
            >
              <a-select-option
                v-for="item in curList"
                :key="item.currencyCode"
                :value="item.currencyCode"
                :label="item.currencyCode"
              >{{ item.currencyCode }}</a-select-option>
            </a-select>
          </a-form-item-rest>
        </div>
      </a-form-item>
      <!-- 成交方式 -->
      <a-form-item v-if="materialForm.bankCode==='99999032'" name="tradeTerms" :label="$t('pages_receive_193')">
        <a-select
          v-model:value="materialForm.tradeTerms"
          option-filter-prop="label"
          allow-clear
          show-search
          :placeholder="$t('common_text_006') + $t('common_text_005')"
        >
          <a-select-option
            v-for="item in tradeTermsValue"
            :key="item.id"
            :value="item.value"
            :label="item.value"
          >{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 商品信息 -->
      <a-form-item v-if="materialForm.bankCode==='99999032'" name="goodsInfo" :label="$t('pages_receive_192')">
        <div v-for="(item, index) in materialForm.goodsInfo" :key="index" class="trade-country-area" style="margin-bottom: 10px;">
          <a-form-item
            :name="['goodsInfo', index, 'goodsName']"
            :rules="{ required: true, message: $t('common_text_006') + $t('pages_receive_195') }"
          >
            <a-input
              v-model:value="item.goodsName"
              size="large"
              allow-clear
              :placeholder="$t('common_text_006') + $t('pages_receive_195')"
            />
          </a-form-item>
          <a-form-item
            :name="['goodsInfo', index, 'goodsNum']"
            :rules="{ required: true, message: $t('common_text_006') + $t('pages_receive_194') }"
          >
            <a-input
              v-model:value="item.goodsNum"
              size="large"
              allow-clear
              :placeholder="$t('common_text_006') + $t('pages_receive_194')"
            />
          </a-form-item>
          <a-form-item
            :name="['goodsInfo', index, 'goodsUnit']"
            :rules="{ required: true, message: $t('common_text_005') + $t('pages_receive_196') }"
            style="margin-bottom: 12px"
          >
            <a-select
              v-model:value="item.goodsUnit"
              show-search
              size="large"
              option-filter-prop="label"
              :placeholder="$t('common_text_005') + $t('pages_receive_196')"
            >
              <a-select-option
                v-for="country in goodsUnitValue"
                :key="country.value"
                :value="country.value"
                :label="country.name"
              >{{ country.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <div class="edit-area">
            <plus-circle-filled v-if="index === 0" class="ic-add" @click="handleEdit(0)" />
            <minus-circle-filled v-else class="ic-delete" @click="handleEdit(index)" />
          </div>
        </div>
      </a-form-item>
      <a-form-item name="tradeDocumentsUrl" :label="$t('pages_receive_088')">
        <upload-auto
          ref="uploadDocRef"
          v-model:file-content="materialForm.tradeDocumentsUrl"
          upload-type="round"
          accept=".jpg,.png,.jepg,.pdf,.bmp,.zip,.rar"
          list-type="picture"
          :max-count="1"
        />
      </a-form-item>
      <a-form-item name="invoiceUrl" :label="$t('pages_receive_089')" style="position: relative">
        <upload-auto
          ref="uploadInvRef"
          v-model:file-content="materialForm.invoiceUrl"
          upload-type="round"
          accept=".jpg,.png,.jepg,.pdf,.bmp,.zip,.rar"
          list-type="picture"
          :max-count="1"
        />
        <div class="form-explain">
          <div>
            <span>{{ $t('pages_receive_095') }}</span>
            <span class="explain-text">{{ $t('pages_receive_096') }}</span>
            <span>{{ $t('pages_receive_097') }}</span>
            <span class="explain-text">{{ $t('pages_receive_098') }}</span>
            <span>{{ $t('pages_receive_099') }}</span>
          </div>
          <div>
            <span>{{ $t('pages_receive_100') }}</span>
            <span class="explain-text">{{ $t('pages_receive_101') }}</span>
            <span>{{ $t('pages_receive_102') }}</span>
          </div>
          <div>
            <span>{{ $t('pages_receive_103') }}</span>
          </div>
        </div>
      </a-form-item>
      <div v-if="materialForm.tradeType === '00'">
        <a-form-item name="logisticsStatus" :label="$t('pages_receive_090')">
          <a-radio-group v-model:value="materialForm.logisticsStatus" button-style="solid" @change="logisticsChange">
            <a-radio-button key="Y" value="1">{{ $t('pages_receive_093') }}</a-radio-button>
            <a-radio-button key="N" value="0">{{ $t('pages_receive_094') }}</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="materialForm.logisticsStatus === '1'" name="logisticsDocumentUrl" :label="$t('pages_receive_091')">
          <upload-auto
            ref="uploadLogRef"
            v-model:file-content="materialForm.logisticsDocumentUrl"
            upload-type="round"
            accept=".jpg,.png,.jepg,.pdf,.bmp,.zip,.rar"
            list-type="picture"
            :max-count="1"
          />
          <div class="form-explain">
            <div>
              <span>{{ $t('pages_receive_095') }}</span>
              <span>{{ $t('pages_receive_097') }}</span>
              <span class="explain-text">{{ $t('pages_receive_104') }}</span>
              <span>{{ $t('pages_receive_105') }}</span>
            </div>
            <div>
              <span>{{ $t('pages_receive_103') }}</span>
            </div>
          </div>
        </a-form-item>
        <a-form-item v-if="materialForm.logisticsStatus === '0'&&inquiryType" name="inquiryUrl" :label="$t('pages_receive_190')">
          <upload-auto
            ref="uploadInqRef"
            v-model:file-content="materialForm.inquiryUrl"
            upload-type="round"
            accept=".jpg,.png,.jepg,.pdf,.bmp,.zip,.rar"
            list-type="picture"
            :max-count="1"
          />
          <div class="form-explain">
            <div>
              <span>{{ $t('pages_receive_191') }}</span>
            </div>
            <div>
              <span>{{ $t('pages_receive_103') }}</span>
            </div>
          </div>
        </a-form-item>
      </div>
      <div v-else>
        <a-form-item name="isOver" :label="$t('pages_receive_109')">
          <a-radio-group v-model:value="materialForm.isOver" button-style="solid" @change="logisticsChange">
            <a-radio-button key="Y" value="1">{{ $t('pages_receive_111') }}</a-radio-button>
            <a-radio-button key="N" value="0">{{ $t('pages_receive_112') }}</a-radio-button>
          </a-radio-group>
        </a-form-item>
      </div>
      <a-form-item v-if="materialForm.logisticsStatus === '0' || materialForm.isOver === '0'" name="planOverDate" :label="materialForm.tradeType === '00' ? $t('pages_receive_092') : $t('pages_receive_110')">
        <a-date-picker
          v-model:value="materialForm.planOverDate"
          format="YYYY/MM/DD"
          value-format="YYYY-MM-DD"
        />
      </a-form-item>
      <a-form-item name="remark" :label="$t('pages_receive_181')">
        <a-textarea
          v-model:value="materialForm.remark"
          allow-clear
          :placeholder="$t('common_text_006') + $t('pages_receive_181')"
        />
      </a-form-item>
      <a-form-item :wrapper-col="{ offset: 10 }" style="margin-top: 64px">
        <a-row :wrap="false">
          <a-button
            :loading="loading"
            html-type="submit"
            type="primary"
            shape="round"
            class="material-btn"
          >{{ $t('common_text_002') }}</a-button>
          <a-button
            shape="round"
            style="margin-left: 18px"
            class="material-btn"
            type="primary"
            ghost
            @click="$router.back(-1)"
          >{{ $t('common_text_003') }}</a-button>
        </a-row>
      </a-form-item>
    </a-form>
    <div v-if="comments" class="error-area">
      <div class="title flex-align">
        <exclamation-circle-outlined class="ic-error" />
        <span>{{ $t('pages_receive_118') }}</span>
      </div>
      <div class="comments">{{ comments }}</div>
    </div>
  </div>
</template>
<script>
import { ref, reactive, toRefs, watch, onUnmounted, watchEffect } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import i18n from '@/locale'
import { _receive } from '@/api'
import { notification } from 'ant-design-vue'
import UploadAuto from '@/components/upload-auto'
export default {
  name: 'Ttrade',
  components: {
    'upload-auto': UploadAuto
  },
  setup() {
    let timer = null
    const route = useRoute()
    const router = useRouter()
    const uploadDocRef = ref(null)
    const uploadInvRef = ref(null)
    const uploadLogRef = ref(null)
    const uploadInqRef = ref(null)

    const state = reactive({
      areaPubs: [],
      curList: [],
      comments: '',
      vaId: '',
      loading: false,
      isAdvance: route.query.isAdvance,
      isUpdate: route.query.isUpdate,
      isReset: route.query.isReset,
      saleWebSite: '',
      materialForm: {
        bankAccountNo: '',
        bankCode: '',
        saleWebSite: '',
        tradeType: '',
        payType: '02',
        payerName: '',
        payerCountry: null,
        currency: '',
        totalAmount: '',
        receiveAmount: '',
        tradeDocumentsUrl: '',
        logisticsStatus: '1',
        logisticsDocumentUrl: '',
        inquiryUrl: '',
        planOverDate: '',
        isOver: '1',
        remark: '',
        tradeTerms: '',
        goodsInfo: [{ goodsNum: null, goodsName: null, goodsUnit: null }]
      },
      materialRules: {
        saleWebSite: [{ required: true }],
        payerName: [{ required: true }],
        payerCountry: [{ required: true }],
        totalAmount: [{ required: true }],
        tradeDocumentsUrl: [{ required: true, message: i18n.global.t('common_text_007') + i18n.global.t('pages_receive_088') }],
        invoiceUrl: [{ required: true, message: i18n.global.t('common_text_007') + i18n.global.t('pages_receive_089') }],
        logisticsStatus: [{ required: true }],
        isOver: [{ required: true }],
        logisticsDocumentUrl: [{ required: true, message: i18n.global.t('common_text_007') + i18n.global.t('pages_receive_091') }],
        inquiryUrl: [{ required: true, message: i18n.global.t('common_text_007') + i18n.global.t('pages_receive_190') }],
        planOverDate: [{ required: true }],
        receiveAmount: [{ required: true }],
        payType: [{ required: true }],
        tradeTerms: [{ required: true }],
        goodsInfo: [{ required: true }]
      },
      materialInfo: {},
      inquiryType: true,
      payTypeValue: [
        { name: '预付款+尾款', value: '01' }, { name: '全款', value: '02' }
      ],
      tradeTermsValue: [
        { name: 'EXW 工厂交货', value: 'EXW' },
        { name: 'FCA 货交承运人', value: 'FCA' },
        { name: 'FAS 船边交货', value: 'FAS' },
        { name: 'FOB 船上交货', value: 'FOB' },
        { name: 'CFR 成本加运费付至', value: 'CFR' },
        { name: 'CIF 成本，保险加运费付至', value: 'CIF' },
        { name: 'CPT 运费付至', value: 'CPT' },
        { name: 'CIP 运费和保险费付至', value: 'CIP' },
        { name: 'DAT 终点站交货', value: 'DAT' },
        { name: 'DES 目的港船上交货', value: 'DES' },
        { name: 'DEQ 目的港码头交货', value: 'DEQ' },
        { name: 'DDU 未完税交货', value: 'DDU' },
        { name: 'DDP 完税后交货', value: 'DDP' }
      ],
      goodsUnitValue: [
        { name: 'PCS(件)', value: 'PCS' },
        { name: 'SETS(套)', value: 'SETS' },
        { name: 'G(克)', value: 'G' },
        { name: 'KG(公斤)', value: 'KG' },
        { name: 'MT/TON(吨)', value: 'MT/TON' },
        { name: 'YARDS(码)', value: 'YARDS' },
        { name: 'ROLLS(卷)', value: 'ROLLS' },
        { name: 'PAIRS(对)', value: 'PAIRS' }
      ]
    })

    onUnmounted(() => {
      sessionStorage.removeItem('vaList')
      sessionStorage.removeItem('materialInfo')
    })

    const logisticsChange = (e) => {
      if (e.target.value === '1') {
        state.materialForm.planOverDate = null
        state.materialForm.inquiryUrl = ''
      } else {
        state.materialForm.logisticsDocumentUrl = ''
      }
    }

    const materialSubmit = async () => {
      state.loading = true
      const { materialInfo } = state
      const data = Object.assign({}, state.materialForm, {})
      if (state.materialForm.tradeType === '00') {
        delete data.saleWebSite
        delete data.isOver
      } else {
        delete data.logisticsStatus
        delete data.logisticsDocumentUrl
        delete data.inquiryUrl
      }
      if (!state.isAdvance) {
        data.applyNo = materialInfo.applyNo
        data.amountLimit = materialInfo.fillAmt
        data.entryAmount = materialInfo.receiveAmount
        data.entryCurrency = materialInfo.currency
      }
      if (materialInfo.bankCode === '99999032') {
        data.goodsInfo = JSON.stringify(state.materialForm.goodsInfo)
      } else {
        data.goodsInfo = null
      }
      const res = await _receive.receiveTradeOrderSave(data)
      state.loading = false
      if (res.data.succ) {
        notification.success({
          message: i18n.global.t('common_text_018'),
          description: i18n.global.t('pages_receive_119')
        })
        router.back(-1)
      } else {
        notification.error({
          message: i18n.global.t('common_text_015'),
          description: res.data.resMsg
        })
      }
    }

    const loadAreaPub = async () => {
      const res = await _receive.getAreaPub()
      if (res.data.succ) {
        state.areaPubs = res.data.data
      }
    }

    const loadAllCurrency = async () => {
      const res = await _receive.getAllCurrency()
      if (res.data.succ) {
        state.curList = res.data.data
      }
    }

    const loadAllVAs = async () => {
      let vaList = sessionStorage.getItem('vaList')
      if (vaList) {
        vaList = JSON.parse(vaList)
      } else {
        const res = await _receive.getAllVAs()
        if (res.data.succ) vaList = res.data.data
      }
      if (state.vaId) {
        const vaInfo = vaList.find(va => va.id === state.vaId)
        state.materialForm.currency = vaInfo.currencyList[0]
        state.materialForm.tradeType = vaInfo.transType === '20' ? '00' : '01'
        state.materialForm.bankAccountNo = vaInfo.accountNo
        if (vaInfo.transType === '30') {
          state.saleWebSite = vaInfo.saleWebSite
          state.materialForm.saleWebSite = vaInfo.saleWebSite
        }
      }
    }

    const loadAccountDetails = async () => {
      const materialInfo = sessionStorage.getItem('materialInfo')
      if (materialInfo) {
        state.materialInfo = JSON.parse(materialInfo)
        state.materialForm.currency = state.materialInfo.currency
        state.materialForm.bankCode = state.materialInfo.bankCode
        state.materialForm.tradeType = state.materialInfo.transType === '20' ? '00' : '01'
        state.materialForm.bankAccountNo = state.materialInfo.receiveAccount
        if (state.materialInfo.transType === '30') {
          let vaList = sessionStorage.getItem('vaList')
          if (vaList) {
            vaList = JSON.parse(vaList)
          } else {
            const res = await _receive.getAllVAs()
            if (res.data.succ) vaList = res.data.data
          }
          const vaInfo = vaList.find(va => va.accountNo === state.materialInfo.receiveAccount)
          state.saleWebSite = vaInfo.saleWebSite
          state.materialForm.saleWebSite = vaInfo.saleWebSite
        }
      } else {
        router.replace('/home/index')
      }
    }

    const loadVaDetails = async () => {
      const { materialInfo } = state
      const res = await _receive.getReceiveTradeDetailByNo({ batchNo: materialInfo.batchNo })
      if (res.data.succ) {
        const { data } = res.data
        state.comments = data.comments
        state.materialForm.isModify = materialInfo.status === '08' ? '1' : '0'
        if (materialInfo.status === '08') state.materialForm.id = data.id
        state.materialForm.payerName = data.payerName
        state.materialForm.payerCountry = data.payerCountry
        state.materialForm.totalAmount = data.totalAmount
        state.materialForm.currency = data.currency
        state.materialForm.tradeDocumentsUrl = data.tradeDocumentsUrl
        state.materialForm.invoiceUrl = data.invoiceUrl
        state.materialForm.planOverDate = data.planOverDate === 'null' ? null : data.planOverDate
        state.materialForm.remark = data.remark

        state.materialForm.payType = data.payType
        state.materialForm.receiveAmount = data.receiveAmount
        state.materialForm.tradeTerms = data.tradeTerms
        state.materialForm.goodsInfo = data.goodsList || [{ goodsNum: null, goodsName: null, goodsUnit: null }]

        if (data.tradeDocumentsUrlList) uploadDocRef.value.fileListRefresh(data.tradeDocumentsUrlList)
        if (data.invoiceUrlList) uploadInvRef.value.fileListRefresh(data.invoiceUrlList)
        if (materialInfo.transType === '20') {
          state.materialForm.logisticsDocumentUrl = data.logisticsDocumentUrl
          state.materialForm.logisticsStatus = data.logisticsStatus
          if (data.logisticsDocumentUrlList) uploadLogRef.value.fileListRefresh(data.logisticsDocumentUrlList)
          state.materialForm.inquiryUrl = data.inquiryUrl
          if (data.inquiryUrlList) uploadInqRef.value.fileListRefresh(data.inquiryUrlList)
        } else {
          state.saleWebSite = data.saleWebSite
          state.materialForm.saleWebSite = data.saleWebSite
          state.materialForm.isOver = data.isOver
        }
      }
    }

    const initPage = () => {
      if (route.query.vaId) state.vaId = +route.query.vaId
      loadAreaPub()
      loadAllCurrency()
      if (state.isAdvance) loadAllVAs()
      else loadAccountDetails()
      if (state.isReset || state.isUpdate) loadVaDetails()
    }

    watch(
      () => router.currentRoute.value,
      (value) => {
        if (value.name === 'materialTrade') initPage()
      },
      { immediate: true }
    )
    watchEffect(() => {
      if (state.materialForm.payerName) {
        clearInterval(timer)
        timer = setInterval(() => {
          clearInterval(timer)
          checkNeedInquiry(state.materialForm.payerName)
        }, 300)
      }
    })
    onUnmounted(() => {
      clearInterval(timer)
    })
    const checkNeedInquiry = async (payerName) => {
      // if (!payerName || props.refused) return
      const res = await _receive.checkNeedInquiry({ payerName })
      console.log(res, 'checkNeedInquiry++++')
      if (res.data.succ) {
        state.inquiryType = res.data.data
      }
      if (state.materialInfo.bankCode === '99999032') {
        state.inquiryType = true
      }
    }
    const handleEdit = (currentIndex) => {
      if (currentIndex) state.materialForm.goodsInfo = state.materialForm.goodsInfo.filter((item, index) => index !== currentIndex)
      else state.materialForm.goodsInfo.push({ goodsNum: null, goodsName: null, goodsUnit: null })
    }
    return {
      uploadDocRef,
      uploadInvRef,
      uploadLogRef,
      uploadInqRef,
      materialSubmit,
      handleEdit,
      logisticsChange,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#tTrade {
  display: flex;
  margin-top: 12px;
  .material-fill {
    width: 500px;
    .area-select {
      left: 1px;
      top: 1px;
      bottom: 1px;
    }
     .area-select:deep(.ant-select-selection-item){
        line-height: 32px;
      }
    .ant-form-item-has-error:deep(.area) {
      border: 1px solid @error-color !important;
    }
    .form-explain {
      background: @table-th-color;
      padding: 12px 36px;
      border-radius: 500px;
      font-size: 12px;
      display: inline-block;
      margin-top: 12px;
      width: 688px;
      .explain-text {
        color: @main-color;
      }
    }
    .material-btn {
      min-width: 138px;
    }
  }
  .error-area {
    width: 250px;
    height: 300px;
    margin-left: 88px;
    padding: 12px 24px;
    border-radius: 7px;
    color: @error-color;
    background: #fef0f0;
    overflow-y: scroll;
    word-break: break-word;
    .title {
      font-weight: 500;
      .ic-error {
        font-size: 20px;
        margin-right: 12px;
      }
    }
    .comments {
      white-space: pre-wrap;
      margin-top: 12px;
    }
  }
}
</style>

